module.exports = __webpack_public_path__ + "img/pistol.eoka.46de1677.png";